interface PaginationProps {
  page: number;
  totalPages: number;
  label: string;
  disabled: boolean;
  onChange: (page: number) => void;
}

/**
 * Rodapé ‹ 1–50 de 1.482 linhas ›, como no design. O texto do meio vem pronto
 * de quem usa, porque cada tela conta uma coisa (linhas, execuções…).
 */
export function Pagination({ page, totalPages, label, disabled, onChange }: PaginationProps) {
  const button =
    'border-line-300 text-navy-800 hover:border-navy-800 rounded-[10px] border bg-white px-3.5 py-2 text-[14px] font-extrabold disabled:opacity-40 disabled:hover:border-line-300';

  return (
    <div className="mt-3.5 flex items-center justify-center gap-3.5">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={disabled || page <= 1}
        className={button}
      >
        ‹<span className="sr-only">Página anterior</span>
      </button>

      <span className="text-ink-600 text-[13px] font-semibold">{label}</span>

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={disabled || page >= totalPages}
        className={button}
      >
        ›<span className="sr-only">Próxima página</span>
      </button>
    </div>
  );
}
